module.exports = __webpack_public_path__ + "static/media/flag-he.7401b69f.webp";